import { isEmpty, cloneDeep } from 'lodash';

import {
    mouseMoveCanvasState,
    contentTranslateState,
    contentScaleState,
    prepareStateEditing,
    finalizeScaling,
    snapToCenterState,
} from './engineState';

import {
    manageResizerStateAdjustments,
    getScaledDataURI,
} from './engineCore';

import {
    renderUpdates,
} from './engineRenderer';

import {
    pushEditorStates,
} from '../../store/models/buttons/undoHelper';

const EditorActions = {
    CANVAS_RESIZE: 'canvas-resize',
    CONTENT_MOVE: 'content-move',
    CONTENT_SCALE: 'content-scale',
};

export function handleDotMouseDown (e, target) {
    // initialize the active editor state
    try {
        if (!window.editorAction) {
            window.editorAction = EditorActions.CANVAS_RESIZE;
            prepareStateEditing({ e, target });
        }
    } catch (err) {
        console.log('handleMouseDown() error -> ', err);
    }
}

export function handleDotMouseUp (e, target) {
    try {
        if (window.activeEditorState && window.editorAction === EditorActions.CANVAS_RESIZE) {
            snapToCenter();
            window.editorState = {
                ...window.activeEditorState,
            };
            window.activeEditorState = null;
            delete window.editorAction;
            dispatchChangeEvent();
        }
    } catch (err) {
        console.log('handleDotMouseUp() error -> ', err);
    }
}

function snapToCenter () {
    const newState = {
        ...window.activeEditorState,
        ...snapToCenterState({
            state: window.activeEditorState,
        }),
    };
    window.activeEditorState = newState;
    window.currentEditorState = cloneDeep(window.activeEditorState);
    pushEditorStates();
    renderUpdates();
}

export function handleWorkspaceMouseMove (event) {
    try {
        if (!isEmpty(window.activeEditorState) && window.editorAction === EditorActions.CANVAS_RESIZE) {
            const updates = manageResizerStateAdjustments({
                event,
                state: { ...window.activeEditorState },
                ui: window.editorUI,
                shape: window.editorUI.shape,
                limits: window.editorLimits,
            });
            window.activeEditorState = {
                ...window.activeEditorState,
                ...updates,
            };
            window.currentEditorState = cloneDeep(window.activeEditorState);
            pushEditorStates();
            renderUpdates();
        }
    } catch (err) {
        console.log('handleWorkspaceMouseMove() error -> ', err);
    }
}

export function handleCanvasMouseDown (e) {
    if (!window.editorAction) {
        window.editorAction = EditorActions.CONTENT_MOVE;
        prepareStateEditing({ e });
        updateWithCanvasEvent(e);
    }
}

export function handleCanvasMouseUp (e) {
    if (window.activeEditorState && window.editorAction === EditorActions.CONTENT_MOVE) {
        updateWithCanvasEvent(e);

        window.editorState = {
            ...window.activeEditorState,
        };
        window.activeEditorState = null;
        delete window.editorAction;
        dispatchChangeEvent();
    }
}

function handleCanvasMouseOut (e) {
    if (window.activeEditorState && window.editorAction === EditorActions.CONTENT_MOVE) {
        finalizeMoveEvent(e);
    }
}

function finalizeMoveEvent (e) {
    try {
        if (window.activeEditorState) {
            updateWithCanvasEvent(e);
            window.editorState = {
                ...window.activeEditorState,
            };
            window.activeEditorState = null;
            delete window.editorAction;
            dispatchChangeEvent();
        }
    } catch (err) {
        console.log('finalizeMoveEvent() error: ', err);
    }
}

export function handleCanvasMouseMove (e) {
    if (!isEmpty(window.activeEditorState) && window.editorAction === EditorActions.CONTENT_MOVE) {
        e.preventDefault();
        e.stopPropagation();
        updateWithCanvasEvent(e);
    }
}

export function updateWithCanvasEvent (e) {
    window.activeEditorState.mouse = mouseMoveCanvasState({
        mouse: window.activeEditorState.mouse,
        event: e,
    });
    window.activeEditorState.content = contentTranslateState(window.activeEditorState);
    window.currentEditorState = cloneDeep(window.activeEditorState);
    pushEditorStates();
    renderUpdates();
}

export function handleCanvasWheel (e) {
    e.stopPropagation();
    e.preventDefault();

    if (!window.editorAction) {
        window.editorAction = EditorActions.CONTENT_SCALE;
        prepareStateEditing();
    }

    if (window.editorAction === EditorActions.CONTENT_SCALE) {
        window.activeEditorState.content = contentScaleState({
            event: e,
            state: window.activeEditorState,
            limits: window.editorLimits,
            ui: window.editorUI,
        });
        window.editorState = { ...window.activeEditorState };
        window.currentEditorState = cloneDeep(window.activeEditorState);
        pushEditorStates();
        renderUpdates();
        clearTimeout(window.editorWheelDebounceTO);
        function wheelEnded () {
            finalizeScaling();
            dispatchChangeEvent();
            delete window.editorAction;
            window.activeEditorState = null;
        }
        window.editorWheelDebounceTO = setTimeout(wheelEnded, 200);
    }
}

export function attachMouseEvents (uis) {
    function attach () {
        if (uis.workspace) {
            uis.workspace.addEventListener('mousemove', handleWorkspaceMouseMove);
            uis.workspace.addEventListener('mouseup', handleDotMouseUp);

            uis.canvasSpace.addEventListener('mousedown', handleCanvasMouseDown);
            uis.canvasSpace.addEventListener('mouseup', handleCanvasMouseUp);
            uis.canvasSpace.addEventListener('mousemove', handleCanvasMouseMove);
            uis.canvasSpace.addEventListener('wheel', handleCanvasWheel);
            uis.canvasSpace.addEventListener('mouseout', handleCanvasMouseOut);
        } else {
            setTimeout(attach, 400);
        }
    }
    setTimeout(attach, 400);
}

export function dispatchChangeEvent () {
    const imgURI = getScaledDataURI();
    window.editorOnChangeComplete({
        imageURI: imgURI,
    });
}
